import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Import configs and util modules
import { FormattedMessage } from '../../../../util/reactIntl';
import { LISTING_STATE_DRAFT } from '../../../../util/types';

// Import shared components
import { H3 } from '../../../../components';

// Import modules from this directory
import css from './EditListingTermsOfSalePanel.module.css';
import EditListingTermsOfSaleForm from './EditListingTermsOfSaleForm';

const EditListingTermsOfSalePanel = props => {
  const [saveAsDraft, setSaveAsDraft] = useState(null);
  const {
    className,
    rootClassName,
    listing,
    disabled,
    ready,
    onSubmit,
    submitButtonText,
    panelUpdated,
    updateInProgress,
    errors,
    history
  } = props;
  const { publicData } = listing.attributes || {};
  const { originalOwner, originalReceipt, allowNegotiation, productType, purchasedYear } = publicData || {};
  const classes = classNames(rootClassName || css.root, className);
  const isPublished = listing?.id && listing?.attributes.state !== LISTING_STATE_DRAFT;

  return (
    <div className={classes}>
      <div className={css.container}>

        <H3 as="h1">
          <FormattedMessage
            id="EditListingTermsOfSalePanel.createListingTitle"
            values={{ lineBreak: <br /> }}
          />
        </H3>
        <EditListingTermsOfSaleForm
          className={css.form}
          initialValues={{ originalOwner, originalReceipt, allowNegotiation, purchasedYear }}
          productType={productType}
          onSubmit={values => {
            const { originalOwner, originalReceipt, allowNegotiation, purchasedYear } = values;
            // New values for listing attributes
            const updateValues = {
              publicData: {
                originalOwner,
                originalReceipt,
                allowNegotiation,
                purchasedYear,
                updatedAt: Math.floor(Date.now() / 1000),
              },
            };
            onSubmit(updateValues);
          }}
          saveActionMsg={submitButtonText}
          disabled={disabled}
          ready={ready}
          updated={panelUpdated}
          updateInProgress={updateInProgress}
          fetchErrors={errors}
          autoFocus
          setSaveAsDraft={setSaveAsDraft}
          saveAsDraft={saveAsDraft}
          onSaveDraft={onSubmit}
          history={history}
        />
      </div>
    </div>
  );
};

const { func, object, string, bool } = PropTypes;

EditListingTermsOfSalePanel.defaultProps = {
  className: null,
  rootClassName: null,
  listing: null,
};

EditListingTermsOfSalePanel.propTypes = {
  className: string,
  rootClassName: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
};

export default EditListingTermsOfSalePanel;
